/**
 * EditorColorPicker — color picker with WCAG contrast validation
 */
import { getContrastRatio } from '@/utils/color';

interface EditorColorPickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  bgColor?: string;
}

export function EditorColorPicker({ label, value, onChange, bgColor }: EditorColorPickerProps) {
  const isHex = (c: string) => /^#[0-9a-fA-F]{6}$/.test(c);
  const showContrast = bgColor && isHex(value) && isHex(bgColor);
  const ratio = showContrast ? getContrastRatio(value, bgColor!) : null;
  const isLow = ratio !== null && ratio < 4.5;

  return (
    <div className="field">
      <label className="field-label">{label}</label>
      <div className="field-color">
        <input
          className="field-color-picker"
          type="color"
          value={value || '#000000'}
          onChange={(e) => onChange(e.target.value)}
        />
        <input
          className="field-input"
          type="text"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#000000"
        />
      </div>
      {isLow && (
        <div style={{ color: '#b91c1c', fontSize: 12, marginTop: 4 }}>
          Kontrast {ratio!.toFixed(1)}:1 — WCAG AA erfordert mind. 4.5:1
        </div>
      )}
    </div>
  );
}
